import { Category, useAlert } from '@drawbotics/react-drylus';

import { createTranslate } from '~/utils';

const tt = createTranslate('errors');

interface GoogleErrorResponse {
  error: string;
}

interface useHandleGoogleErrorsOutput {
  showGoogleError: (response: GoogleErrorResponse) => void;
}

export function useHandleGoogleErrors(): useHandleGoogleErrorsOutput {
  const { showAlert } = useAlert();

  const getErrorMessage = (error: string) => {
    switch (error) {
      case 'popup_closed_by_user':
        return tt(error);
      case 'access_denied':
        return tt(error);
      case 'immediate_failed':
        return tt(error);
      default:
        return tt('google_generic');
    }
  };

  const getAlertCategory = (error: string) => {
    switch (error) {
      case 'popup_closed_by_user':
        return Category.INFO;
      default:
        return Category.DANGER;
    }
  };

  const showGoogleError = (response: GoogleErrorResponse) => {
    showAlert({
      text: getErrorMessage(response.error),
      category: getAlertCategory(response.error),
    });
  };

  return { showGoogleError };
}
